module.exports = __webpack_public_path__ + "img/invitation.4523004d.svg";